const initialState = {
  pathname: window.location.pathname,
  search: window.location.search,
  hash: window.location.hash,
};

export default initialState;
